import { render, staticRenderFns } from "./clockHand.vue?vue&type=template&id=6ceafd7e&scoped=true&"
import script from "./clockHand.vue?vue&type=script&lang=js&"
export * from "./clockHand.vue?vue&type=script&lang=js&"
import style0 from "./clockHand.vue?vue&type=style&index=0&id=6ceafd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceafd7e",
  null
  
)

export default component.exports